( function( $ ) {
  $( '.__gallery' ).each( function() {
    var group_name = $( this ).data( 'group' );
    
    if ( $( this ).hasClass( '__slides' ) ) {
      $( '.' + group_name + '-page' ).jPages( {
        containerID : group_name,
        perPage     : 8,
        previous    : false,
        next        : false
      } );
    }
  } );
} ) ( jQuery );